// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { handleOnBlurCoordinateField, handleOnPasteCoordinateField } from 'helpers/coordsConversion'
import React from 'react'
import { func, string } from 'prop-types'
import { reduxForm, Field } from 'redux-form'
import { siteLookupValidator } from 'validators/lookups'
import { ContactField } from './components'
import { FormWrapper } from './styles'

import {
  SubmitErrors,
  UpdatedLabeledInput,
} from 'components/Form'

const Form = props => {
  const {
    error,
    form,
    handleSubmit,
    initialize,
  } = props

  // we use initialize here in place of reset because we need to set all initial values
  // as blanks, not just make the form pristine.
  const clearForm = () => (
    initialize({
      asr: '',
      callSign: '',
      contactId: [],
      latitude: '',
      longitude: '',
      radius: '',
      siteName: '',
    })
  )

  return (
    <FormWrapper
      className={'heading-font'}
      id={'site-lookup'}>
      <SubmitErrors
        error={error}
        idRoot={form}
        sourceForm={form} />
      <Field
        autoFocus={true}
        className={'site-name'}
        component={UpdatedLabeledInput}
        id={`${form}-site-name`}
        label={'Site Name'}
        name={'siteName'}
        placeholder={'Site Name'} />
      <Field
        className={'call-sign'}
        component={UpdatedLabeledInput}
        id={`${form}-call-sign`}
        label={'Call Sign'}
        name={'callSign'}
        placeholder={'Call Sign'} />
      <Field
        className={'asr'}
        component={UpdatedLabeledInput}
        id={`${form}-asr`}
        label={'ASR'}
        name={'asr'}
        placeholder={'ASR'} />
      <ContactField
        idRoot={form}
        name={'contactId'}
        sourceForm={form} />
      <button
        className={'submit btn search-button big-button'}
        id={`${form}-submit`}
        onClick={handleSubmit}
        type={'submit'}>
        {'Search'}
      </button>
      <Field
        className={'latitude'}
        component={UpdatedLabeledInput}
        id={`${form}-latitude`}
        label={'Latitude'}
        name={'latitude'}
        onBlurCustom={handleOnBlurCoordinateField}
        onPasteCustom={handleOnPasteCoordinateField}
        placeholder={'Latitude'} />
      <Field
        className={'longitude'}
        component={UpdatedLabeledInput}
        id={`${form}-longitude`}
        label={'Longitude'}
        name={'longitude'}
        onBlurCustom={handleOnBlurCoordinateField}
        onPasteCustom={handleOnPasteCoordinateField}
        placeholder={'Longitude'} />
      <Field
        className={'radius'}
        component={UpdatedLabeledInput}
        id={`${form}-radius`}
        label={'Radius (km)'}
        name={'radius'}
        placeholder={'0-10 km'} />
      <p
        className={'clear btn search-button big-button bg-pink text-white display-block'}
        id={`${form}-clear`}
        onClick={clearForm}>
        {'Clear'}
      </p>

    </FormWrapper>
  )
}

Form.propTypes = {
  error: string,
  form: string.isRequired,
  handleSubmit: func.isRequired,
  initialize: func.isRequired,
}

const { validate } = siteLookupValidator

export default reduxForm({
  validate,
})(Form)
